import { render, staticRenderFns } from "./EmatLoader.vue?vue&type=template&id=d8242b40&scoped=true&"
import script from "./EmatLoader.vue?vue&type=script&lang=js&"
export * from "./EmatLoader.vue?vue&type=script&lang=js&"
import style0 from "./EmatLoader.vue?vue&type=style&index=0&id=d8242b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8242b40",
  null
  
)

export default component.exports